<template>
  <div class="animated fadeIn">
    <Forms ref="frmCampanhaModelo"
      :title="'CADASTRO DE MODELOS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do modelo'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtName"><small class="text-danger">*</small> Finalidade:</label>
          <div class="input-group">
            <b-form-select v-model="form.finalidade.value" :options="form.finalidade.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtName"><small class="text-danger">*</small> Tipo:</label>
          <div class="input-group">
            <b-form-select v-model="form.tipo.value" :options="form.tipo.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName"><small class="text-danger">*</small> Origem do Lead:</label>
          <div class="input-group">
            <b-form-select v-model="form.origemId.value" :options="form.origemId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtName">Quadro</label>
          <div class="input-group">
            <b-form-select v-model="form.boardId.value" :options="form.boardId.options" @change="onChangeBoard">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4 ">
          <label for="txtName">Coluna:</label>
          <div class="input-group">
            <b-form-select v-model="form.boardColumnId.value" :options="form.boardColumnId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName">URL Redirecionamento:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-external-link-square-alt"></i></span>
            <b-form-input
              type="text"
              :placeholder="'https://minhacampanha.com/visualizar'"
              v-model="form.urlRedirecionamento.value"
              :required="form.urlRedirecionamento.required"
              :state="form.urlRedirecionamento.state"></b-form-input>
          </div>
        </div>
      </div>
      <div v-if="form.tipo.value === 1" class="row pt-2">
        <div class="col-md-12 pb-3">
          <label ><small v-if="form.tituloEmail.required" class="text-danger">*</small> Assunto do e-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o assunto do e-mail'"
                          v-model="form.tituloEmail.value"
                          :size="form.tituloEmail.maxlength"
                          :required="form.tituloEmail.required"
                          :state="form.tituloEmail.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label>Mensagem:</label>
          <mavon-editor
            ref="refMavonEditor"
            class="mavonEditor"
            v-model="form.template.value"
            language="pt-BR"
            :toolbars="toolbars"
            :subfield="false"
            :boxShadow="false"
          >
            <template slot="left-toolbar-before">
              <div
                v-for="option in customToolbar"
                :key="option.name"
                type="button"
                :title="option.name"
                class="op-icon fa dropdown dropdown-wrapper"
                :class="`${option.icon}`"
                aria-hidden="true"
                @mouseleave="option.items ? mouseLeaveDropdown(option) : undefined"
                @mouseenter="option.items ? mouseEnterDropdown(option) : undefined"
                @click="option.items ? undefined : insertText(option)">
                  <transition name="fade">
                      <div
                        class="op-header popup-dropdown"
                        :class="{'transition': true}"
                        v-show="option.dropdownOpen"
                        @mouseenter="mouseEnterDropdown(option)"
                        @mouseleave="mouseLeaveDropdown(option)"
                      >
                          <div
                            v-for="item in option.items"
                            :key="item.name"
                            :title="item.Name"
                            class="dropdown-item"
                            @click="insertText(item)"
                          >
                            <span>{{item.name}}</span>
                          </div>
                      </div>
                  </transition>
              </div>
            </template>
          </mavon-editor>
        </div>
        <div class="col-md-6">
          <label for="txtDescription"> Preview:</label>
          <div style="border: solid 1px #ccc; border-radius: 3px; min-width: 100%;min-height: 543px; max-height: 543px; padding: 7px; overflow: scroll;">
            <div v-html="form.template.value"></div>
          </div>
        </div>
      </div>
      <div v-else class="form-group row pt-2">
        <div class="col-md-12">
          <label>Mensagem:</label>
          <div class="nxbr-toolbar">
            <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-address-card text-third"/>
              </template>
              <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOptionTextArea('@Nome@')">Nome</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOptionTextArea('@Telefone@')">Telefone</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOptionTextArea('@CTA@')">Link de Conversão</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="input-group">
            <b-form-textarea
              v-model="form.template.value"
              ref="templateText"
              :placeholder="'Coloque aqui sua mensagem!'"
              :rows="form.template.rows"
              :size="form.template.maxlength"
              :noResize="true">
            </b-form-textarea>
          </div>
        </div>
        <p class="col-md-12">
          {{ form.template.value ? form.template.value.length : 0 }}/{{ form.template.maxlength }}
        </p>
      </div>
    </Forms>
  </div>
</template>
<script>
/* https://github.com/hinesboy/mavonEditor/blob/master/README-EN.md */
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'
import CampanhaModeloRepository from '@/shared/http/repositories/configurations/templates.js'
import CampanhaModeloModel from '@/shared/models/configurations/campanhamodelomodel.js'
import CampanhaModeloForms from './campanhamodeloadd-form.js'

export default {
  name: 'CampanhaModeloAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: CampanhaModeloModel,
      form: CampanhaModeloForms,
      toolbars: {
        bold: false,
        italic: false,
        header: false,
        underline: false,
        strikethrough: false,
        mark: false,
        superscript: false,
        subscript: false,
        quote: false,
        ol: false,
        ul: false,
        link: false,
        imagelink: false,
        code: false,
        table: false,
        fullscreen: false,
        readmodel: false,
        htmlcode: false,
        help: false,
        undo: false,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: false
      },
      customToolbar: {
        bold: {
          name: 'Negrito',
          icon: 'fa-mavon-bold text-third',
          prefix: '<b>',
          subfix: '</b>',
          str: ''
        },
        italic: {
          name: 'Itálico',
          icon: 'fa-mavon-italic text-third',
          prefix: '<i>',
          subfix: '</i>',
          str: ''
        },
        header: {
          name: 'Cabeçalho',
          icon: 'fa-mavon-header text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Cabeçalho 1',
              prefix: '<h1>',
              subfix: '</h1>',
              str: ''
            },
            {
              name: 'Cabeçalho 2',
              prefix: '<h2>',
              subfix: '</h2>',
              str: ''
            },
            {
              name: 'Cabeçalho 3',
              prefix: '<h3>',
              subfix: '</h3>',
              str: ''
            },
            {
              name: 'Cabeçalho 4',
              prefix: '<h4>',
              subfix: '</h4>',
              str: ''
            },
            {
              name: 'Cabeçalho 5',
              prefix: '<h5>',
              subfix: '</h5>',
              str: ''
            },
            {
              name: 'Cabeçalho 6',
              prefix: '<h6>',
              subfix: '</h6>',
              str: ''
            }
          ]
        },
        underline: {
          name: 'Sublinhar',
          icon: 'fa-mavon-underline text-third',
          prefix: '<ins>',
          subfix: '</ins>',
          str: ''
        },
        strikethrough: {
          name: 'Tachar',
          icon: 'fa-mavon-strikethrough text-third',
          prefix: '<del>',
          subfix: '</del>',
          str: ''
        },
        variables: {
          name: 'Variáveis',
          icon: 'fa-address-card text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Nome',
              prefix: '@',
              subfix: '@',
              str: 'Nome'
            },
            {
              name: 'Email',
              prefix: '@',
              subfix: '@',
              str: 'Email'
            },
            {
              name: 'Telefone',
              prefix: '@',
              subfix: '@',
              str: 'Telefone'
            },
            {
              name: 'Link de Conversão',
              prefix: '@',
              subfix: '@',
              str: 'CTA'
            }
          ]
        },
        undo: {
          name: 'Desfazer (CTRL+Z)',
          icon: 'fa-mavon-undo text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        redo: {
          name: 'Resfazer (CTRL+Y)',
          icon: 'fa-mavon-repeat text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        trash: {
          name: 'Limpar (CTRL+BREAKSPACE)',
          icon: 'fa-trash-alt text-third',
          prefix: '',
          subfix: '',
          str: ''
        }
      }
    }
  },
  watch: {
    'form.tipo.value' (val) {
      if (val !== 1) {
        this.form.tituloEmail.value = null
      }
    },
    'form.boardId.value': function (value) {
      if (value) {
        if (this.form.boardColumnId.options.length > 0) {
          this.form.boardColumnId.options = []
          this.form.boardColumnId.value = null
        }
        this.onChangeBoard(value)
      } else {
        this.form.boardColumnId.options = []
        this.form.boardColumnId.value = null
      }
    },
    'form.finalidade.value': function (value) {
      if (value === 2) {
        this.form.tipo.value = 1
      }
    }
  },
  methods: {
    mouseLeaveDropdown (option) {
      option.timer = setTimeout(function () {
        option.dropdownOpen = false
      }, 200)
    },
    mouseEnterDropdown (option) {
      clearTimeout(option.timer)
      option.dropdownOpen = true
    },
    insertText (options) {
      const textArea = this.$refs.refMavonEditor.getTextareaDom()

      this.$refs.refMavonEditor.insertText(textArea, options)

      this.$nextTick(() => {
        let selection = options.subfix.length + textArea.selectionEnd

        textArea.selectionStart = selection
        textArea.selectionEnd = selection

        textArea.focus()
      })
    },
    onLoad () {
      this.onLoadAllBoards()
      this.onLoadAllOrigem()
    },
    onLoadAllOrigem () {
      OriginRepository.GetAll()
        .then((response) => {
          this.form.origemId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onLoadAllBoards () {
      BoardRepository.GetAll()
        .then((response) => {
          this.form.boardId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onChangeBoard (boardId) {
      BoardColumnRepository.Search(boardId, 20, 0)
        .then((response) => {
          this.form.boardColumnId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.tipo) {
          this.form.tipo.value = obj.tipo
        }
        if (obj.boardColumn && obj.boardColumn.board) {
          this.form.boardId.value = obj.boardColumn.board.id
          this.$nextTick(() => {
            this.form.boardColumnId.value = obj.boardColumn.id
          })
        }
        this.form.origemId.value = obj.origemId
        this.form.finalidade.value = obj.finalidade
        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      CampanhaModeloRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      CampanhaModeloRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onAddingOptionTextArea (value) {
      this.form.template.value = this.form.template.value + value + ' '
      this.$refs.templateText.focus()
      return false
    }
  }
}
</script>

<style scoped>
.mavonEditor {
  border: solid 1px #ccc;
  min-width: 100%;
  min-height: 543px;
  max-height: 543px;
  overflow: scroll;
}
.v-note-wrapper.shadow {
  border: solid 1px #ccc;
}
.markdown-body>:first-child {
  background-color: #eceff1 !important;
  border-bottom: solid 1px #cfd8dc;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon,
.v-note-wrapper .v-note-op .v-right-item .op-icon {
  color: #006a5b !important;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon.selected,
.v-note-wrapper .v-note-op .v-right-item .op-icon.selected {
  color: #006a5b !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon:hover,
.v-note-wrapper .v-note-op .v-right-item .op-icon:hover {
  color: #005c50 !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon button, .v-note-wrapper .v-note-op .v-right-item .op-icon button {
  color: #006a5b;
}
button.op-icon {
  color: #006a5b !important;
}
.nxbr-toolbar {
  background-color: #eceff1 !important;
  border-top: solid 1px #cfd8dc;
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/templates/components/add/campanhamodeloadd.vue